import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.substring(1));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    const exchangeSession = async (retries = 2) => {
      try {
        const response = await axios.post(
          `${BACKEND_URL}/api/auth/session`,
          {},
          {
            headers: { 'X-Session-ID': sessionId },
            withCredentials: true,
          }
        );

        const data = response.data || {};
        // Persist session_token to localStorage as a fallback for browsers
        // that block third-party cookies on custom production domains.
        if (data.session_token) {
          localStorage.setItem('session_token', data.session_token);
        }

        const user = { ...data };
        delete user.session_token;

        sessionStorage.removeItem('msf_rules_shown');

        // Clear the hash from URL before navigating
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/dashboard', { state: { user }, replace: true });
      } catch (error) {
        console.error('Session exchange failed:', error);
        if (retries > 0) {
          await new Promise(resolve => setTimeout(resolve, 800));
          return exchangeSession(retries - 1);
        }
        navigate('/login', { replace: true });
      }
    };

    exchangeSession();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
        <p className="mt-4 text-zinc-400">Authenticating...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
